import PropTypes from 'prop-types';
import React, { Component } from 'react';

/**
 * There are some problems with this implementation.
 * 1) On chrome, it's easy to inadvertently change the selection while resizing. PORT-8772
 * 2) On safari, there is a resize handle, but you can't resize.
 * 3) On edge and chrome, you can't resize (the resize property isn't supported)
 * In the future we may want to re-implement this, and virtualize it as well to
 * support large lists.
 */
export default class Listbox extends Component {

  static propTypes = {
    className: PropTypes.string,
    disabled: PropTypes.bool,
    initialSize: PropTypes.number,
    isMultiple: PropTypes.bool,
    listItems: PropTypes.array,
    onChange: PropTypes.func,
    onItemDoubleClick: PropTypes.func,
    onKeyDown: PropTypes.func,
    selectRef: PropTypes.func,
    testName: PropTypes.string,
  }

  constructor() {
    super();
  }

  // Public interface called by the parent to get the selection.
  getSelectedValues() {
    const options = Array.apply(null, this.selectControl.options);
    return options.filter(option => option.selected).map(option => option.value);
  }

  render() {
    const {
      className,
      disabled,
      initialSize,
      isMultiple,
      listItems,
      onChange,
      onItemDoubleClick,
      onKeyDown,
      testName,
    } = this.props;

    // TODO - consider re-implementing without using select - see above.
    return (
      <select
        className={className}
        disabled={disabled}
        data-test-name={testName}
        ref={input => { this.selectControl = input; }}
        multiple={isMultiple}
        onChange={onChange}
        onKeyDown={onKeyDown}
        size={initialSize}
      >
        {listItems && listItems.map(value => {
          return (
            <option
              onDoubleClick={() => { // eslint-disable-line react/jsx-no-bind
                if (!disabled && onItemDoubleClick) {
                  onItemDoubleClick(value);
                }
              }}
              key={`listbox-${value}`}
              value={value}
            >
              {value}
            </option>
          );
        })}
      </select>
    );
  }
}



// WEBPACK FOOTER //
// ./src/portfolio-shared/view/Utilities/Listbox.js